import { authenticated } from './WebRequest';
import { omitNil } from '../mylib/Utils';
import type {
  ApiThunk,
  ReplicationDetailsParameters,
  ReplicationDetailsResponse,
  ReplicationFullSyncParameters,
  ReplicationMessageResponse,
  ReplicationResendOrdersParameters,
  ReplicationRunActionParameters,
} from './types/Replication';

export type {
  ApiThunk,
  ReplicationChannelInfo,
  ReplicationChannelSite,
  ReplicationDetailsParameters,
  ReplicationDetailsResponse,
  ReplicationFullSyncParameters,
  ReplicationInfo,
  ReplicationMessageResponse,
  ReplicationResendOrdersParameters,
  ReplicationRunAction,
  ReplicationRunActionParameters,
  ReplicationServiceInfo,
  ReplicationSiteParameters,
  ReplicationState,
} from './types/Replication';

export default class ReplicationApi {
  static fetchReplicationDetails(
    parameters: ReplicationDetailsParameters
  ): ApiThunk<ReplicationDetailsResponse> {
    const { siteid, ...params } = omitNil(parameters);
    return authenticated.get(`/replication/site/${siteid}/details/`, {
      params,
    });
  }

  static runReplicationAction(
    parameters: ReplicationRunActionParameters
  ): ApiThunk<ReplicationMessageResponse> {
    const { siteid, ...params } = omitNil(parameters);
    return authenticated.get(`/replication/site/${siteid}/runaction/`, {
      params,
    });
  }

  static setReplicationFullSync(
    parameters: ReplicationFullSyncParameters
  ): ApiThunk<ReplicationMessageResponse> {
    const { siteid, ...params } = omitNil(parameters);
    return authenticated.post(`/replication/site/${siteid}/set_full_sync/`, {
      ...params,
    });
  }

  static resendOrders(
    parameters: ReplicationResendOrdersParameters
  ): ApiThunk<ReplicationMessageResponse> {
    const { siteid, ...params } = omitNil(parameters);
    return authenticated.post(`/replication/site/${siteid}/resend_orders/`, {
      ...params,
    });
  }
}
